import { Component, OnInit } from '@angular/core';
import { ApprovalService } from '../../api/services/approval.service';
import { Approval, ApprovalUserInput } from '../../api/models/approval';
import { PaginatedRequest } from '../../api/models/paginated-request';

@Component({
  selector: 'app-approvals',
  templateUrl: './approvals.component.html',
  styleUrls: ['./approvals.component.scss']
})
export class ApprovalsComponent implements OnInit {

  constructor(private approvalService: ApprovalService) {
  }

  approvals: Approval[];
  currentFilter = 'MY_PENDING';
  icon = '&#xe910';
  loading: boolean;
  infoMsg = ['No approval to show!'];

  page = 1;
  pageSize = 20;
  sorting: string = 'creationDate,desc';
  paginatedRequest: PaginatedRequest;
  totalRecords = 0;
  approvalUserInput: ApprovalUserInput;

  filter(option: string) {
    if (this.currentFilter !== option) {
      this.currentFilter = option;
      this.load(1);
    }
  }

  formatString(string: string): string {
    return string.charAt(0) + string.substr(1).toLowerCase();
  }

  getObjectTypeCode(objectid: string) {
    return objectid.split('~')[0];
  }

  isDelegation(objectid: string) {
    return this.getObjectTypeCode(objectid) === 'DELEGATION';
  }

  isWorksheet(objectid: string) {
    return this.getObjectTypeCode(objectid) === 'WORKSHEET';
  }

  getObjectId(objectid: string) {
    return objectid.split('~')[1];
  }

  ngOnInit() {
    this.load(1);
  }

  load(page) {
    this.approvals = [];
    this.setLoading(true);
    this.paginatedRequest = new PaginatedRequest(page, this.pageSize, this.sorting);
    this.approvalUserInput = new ApprovalUserInput();
    if (this.currentFilter !== 'PENDING') {
      this.approvalUserInput = new ApprovalUserInput();
      if (this.currentFilter === 'MY_PENDING') {
        this.approvalUserInput.filter.push('PENDING');
      } else if (this.currentFilter === 'CLOSED') {
        this.approvalUserInput.filter.push('APPROVED');
        this.approvalUserInput.filter.push('DENIED');
      }
      this.approvalService.getAllApprovals(this.approvalUserInput, this.paginatedRequest).subscribe(paginatedApprovalResponse => {
        this.setLoading(false);
        if (paginatedApprovalResponse.totalRecords && paginatedApprovalResponse.totalRecords > 0) {
          this.totalRecords = paginatedApprovalResponse.totalRecords;
          this.approvals = paginatedApprovalResponse.records;
        } else {
          this.approvals = [];
        }
      }, error => {
        this.approvals = [];
        this.setLoading(false);
      });
    } else {
      this.paginatedRequest.sorting = 'creation_date,desc';
      this.approvalService.getAllPendingApprovals(this.paginatedRequest).subscribe(paginatedApprovalResponse => {
        this.setLoading(false);
        if (paginatedApprovalResponse.totalRecords && paginatedApprovalResponse.totalRecords > 0) {
          this.totalRecords = paginatedApprovalResponse.totalRecords;
          this.approvals = paginatedApprovalResponse.records;
        } else {
          this.approvals = [];
        }
      }, error => {
        this.approvals = [];
        this.setLoading(false);
      });
    }
  }

  getLoading() {
    return this.loading;
  }

  setLoading(value: boolean) {
    this.loading = value;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/approvals/approvals.component.ts